// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__nq-B7","title":"Modal_title__HWYLg","text":"Modal_text__F1IBx","button":"Modal_button__6q8P7"};